/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileUploadDto } from './FileUploadDto';
import {
    FileUploadDtoFromJSON,
    FileUploadDtoFromJSONTyped,
    FileUploadDtoToJSON,
} from './FileUploadDto';

/**
 * 
 * @export
 * @interface DemandeInscriptionFichierUploadDto
 */
export interface DemandeInscriptionFichierUploadDto {
    /**
     * 
     * @type {FileUploadDto}
     * @memberof DemandeInscriptionFichierUploadDto
     */
    file?: FileUploadDto;
    /**
     * 
     * @type {number}
     * @memberof DemandeInscriptionFichierUploadDto
     */
    iddemandeInscriptionFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof DemandeInscriptionFichierUploadDto
     */
    iddemandeInscription?: number;
    /**
     * 
     * @type {number}
     * @memberof DemandeInscriptionFichierUploadDto
     */
    idfichier?: number;
    /**
     * 
     * @type {string}
     * @memberof DemandeInscriptionFichierUploadDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the DemandeInscriptionFichierUploadDto interface.
 */
export function instanceOfDemandeInscriptionFichierUploadDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DemandeInscriptionFichierUploadDtoFromJSON(json: any): DemandeInscriptionFichierUploadDto {
    return DemandeInscriptionFichierUploadDtoFromJSONTyped(json, false);
}

export function DemandeInscriptionFichierUploadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DemandeInscriptionFichierUploadDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : FileUploadDtoFromJSON(json['file']),
        'iddemandeInscriptionFichier': !exists(json, 'iddemandeInscriptionFichier') ? undefined : json['iddemandeInscriptionFichier'],
        'iddemandeInscription': !exists(json, 'iddemandeInscription') ? undefined : json['iddemandeInscription'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function DemandeInscriptionFichierUploadDtoToJSON(value?: DemandeInscriptionFichierUploadDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': FileUploadDtoToJSON(value.file),
        'iddemandeInscriptionFichier': value.iddemandeInscriptionFichier,
        'iddemandeInscription': value.iddemandeInscription,
        'idfichier': value.idfichier,
        'fileName': value.fileName,
    };
}

